var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#00848D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_205_756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#00848D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_205_756)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8703 28.705C25.8703 25.1394 27.2834 21.7198 29.7987 19.1985C32.314 16.6773 35.7255 15.2609 39.2828 15.2609C42.84 15.2609 46.2515 16.6773 48.7668 19.1985C51.2822 21.7198 52.6953 25.1394 52.6953 28.705C52.6953 32.2705 51.2822 35.6901 48.7668 38.2114C46.2515 40.7326 42.84 42.149 39.2828 42.149C35.7255 42.149 32.314 40.7326 29.7987 38.2114C27.2834 35.6901 25.8703 32.2705 25.8703 28.705ZM14.6962 70.8447C14.7967 64.375 17.4312 58.2044 22.0312 53.6649C26.6311 49.1253 32.8275 46.581 39.2828 46.581C45.738 46.581 51.9344 49.1253 56.5343 53.6649C61.1343 58.2044 63.7688 64.375 63.8694 70.8447C63.8771 71.2802 63.758 71.7086 63.5267 72.0774C63.2954 72.4462 62.9618 72.7393 62.5668 72.9211C55.262 76.2782 47.3188 78.0108 39.2828 77.9999C30.9789 77.9999 23.0894 76.1835 15.9987 72.9211C15.6037 72.7393 15.2701 72.4462 15.0388 72.0774C14.8075 71.7086 14.6884 71.2802 14.6962 70.8447Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatarPlaceholder.23d8b9a8f2525e7106c779101a3130ff.svg";
export { ForwardRef as ReactComponent };